/* eslint-disable */
// @ts-nocheck

// Scripts used for Gallery modules.
// This script is extracted from frontend-scripts to be used in Divi's Dynamic Assets system.
(function ($) {
  $(window).on('et_pb_init_modules', function () {
    window.et_pb_init_gallery_modules = function () {
      // D5 Visual Builder does not set window.ET_Builder; detect the app root instead so
      // gallery APIs are still exposed for React modules that mount after this script boots.
      var isBuilder = 'object' === typeof window.ET_Builder || 0 < $('#et-fb-app').length;
      var $et_pb_gallery = $('.et_pb_gallery');
      var $et_post_gallery = $('.et_post_gallery');
      var isBlockLayoutPreview =
        'undefined' !== typeof window.ETBlockLayoutModulesScript && $('body').hasClass('et-block-layout-preview');

      // Document Ready
      $(() => {
        if (!isBlockLayoutPreview && $et_post_gallery.length > 0 && $.magnificPopup) {
          // swipe support in magnific popup only if gallery exists
          const magnificPopup = $.magnificPopup.instance;

          $('body').on('swiperight', '.mfp-container', () => {
            if (magnificPopup) {
              magnificPopup.prev();
            }
          });
          $('body').on('swipeleft', '.mfp-container', () => {
            if (magnificPopup) {
              magnificPopup.next();
            }
          });

          $et_post_gallery.each(function () {
            $(this).magnificPopup({
              delegate: '.et_pb_gallery_image a',
              type: 'image',
              removalDelay: 500,
              gallery: {
                enabled: true,
                navigateByImgClick: true,
              },
              mainClass: 'mfp-fade',
              zoom: {
                enabled: window.et_pb_custom && !window.et_pb_custom.is_builder_plugin_used,
                duration: 500,
                opener(element) {
                  return element.find('img');
                },
              },
              autoFocusLast: false,
            });
          });

          // prevent attaching of any further actions on click
          $et_post_gallery.find('a').off('click');
        }

        if ($et_pb_gallery.length || isBuilder) {
          window.set_gallery_grid_items = function ($the_gallery) {
            const $the_gallery_items_container = $the_gallery.find('.et_pb_gallery_items');
            const $the_gallery_items = $the_gallery_items_container.find('.et_pb_gallery_item');

            var total_grid_items = $the_gallery_items.length;
            const posts_number_original = parseInt($the_gallery_items_container.attr('data-per_page'));
            const posts_number =
              isNaN(posts_number_original) || 0 === posts_number_original ? 4 : posts_number_original;
            const pages = Math.ceil(total_grid_items / posts_number);

            set_gallery_grid_pages($the_gallery, pages);

            var total_grid_items = 0;
            let _page = 1;

            $the_gallery_items.data('page', '');
            $the_gallery_items.each(function (i) {
              total_grid_items++;

              // Do some caching
              const $this = $(this);
              if (0 === parseInt(total_grid_items % posts_number)) {
                $this.data('page', _page);
                _page++;
              } else {
                $this.data('page', _page);
              }
            });

            $the_gallery_items
              .filter(function () {
                return 1 == $(this).data('page');
              })
              .show();

            $the_gallery_items
              .filter(function () {
                return $(this).data('page') != 1;
              })
              .hide();

            // Size after page-one visibility is established (matches pagination path).
            window.et_pb_set_responsive_grid($the_gallery_items_container, '.et_pb_gallery_item:visible');
          };

          window.set_gallery_grid_pages = function ($the_gallery, pages) {
            const $pagination = $the_gallery.find('.et_pb_gallery_pagination');

            if (!$pagination.length) {
              return;
            }

            $pagination.html('<ul></ul>');
            if (pages <= 1) {
              $pagination.hide();
              return;
            } else {
              $pagination.show();
            }

            const $pagination_list = $pagination.children('ul');
            $pagination_list.empty(); // Clear previous pagination

            const totalPages = pages; // Total number of pages.
            const maxVisiblePages = 4; // Max pages to show at once.
            let currentPage = 1; // Initialize the current page.

            $pagination_list.append(
              `<li class="prev" style="display:none;"><a href="#" data-page="prev" class="page-prev">${et_pb_custom.prev}</a></li>`,
            );
            // Add "Prev" ellipsis if we're not on page 1.
            $pagination_list.append(`<li style="display:none;" class="prev-dots">...</li>`);

            // Show the first 4 pages and the ellipsis if necessary
            for (let page = 1; page <= totalPages; page++) {
              const firstPageClass = page === 1 ? ' active' : '';
              const lastPageClass = page === totalPages ? ' last-page' : '';

              // Logic to display ellipsis
              const hiddenPageClass = page > maxVisiblePages ? ' style="display:none;"' : '';

              // Append page numbers
              $pagination_list.append(
                `<li${hiddenPageClass} class="page page-${page}"><a href="#" data-page="${page}" class="page-${page}${firstPageClass}${lastPageClass}">${page}</a></li>`,
              );
            }

            // Show ellipsis if there are more than 4 pages and the last page is not shown yet.
            if (totalPages > maxVisiblePages && currentPage + maxVisiblePages <= totalPages) {
              // Only show the ellipsis if the last page is not visible.
              $pagination_list.append(`<li class="next-dots">...</li>`);
            }

            // Show the "Next" button if not on the last page.
            if (currentPage < totalPages) {
              $pagination_list.append(
                `<li class="next"><a href="#" data-page="next" class="page-next">${et_pb_custom.next}</a></li>`,
              );
            }
          };

          window.set_gallery_hash = function ($the_gallery) {
            if (!$the_gallery.attr('id')) {
              return;
            }

            let this_gallery_state = [];
            this_gallery_state.push($the_gallery.attr('id'));

            if ($the_gallery.find('.et_pb_gallery_pagination a.active').length) {
              this_gallery_state.push($the_gallery.find('.et_pb_gallery_pagination a.active').data('page'));
            } else {
              this_gallery_state.push(1);
            }

            this_gallery_state = this_gallery_state.join(et_hash_module_param_seperator);

            setHash(this_gallery_state);
          };

          window.et_pb_gallery_init = function ($the_gallery) {
            if ($the_gallery.hasClass('et_pb_gallery_grid')) {
              $the_gallery.show();
              set_gallery_grid_items($the_gallery);

              $the_gallery.on('et_hashchange', event => {
                const { params } = event;
                $the_gallery = $(`#${event.target.id}`);
                const page_to = params[0];

                if (page_to) {
                  if (!$the_gallery.find(`.et_pb_gallery_pagination a.page-${page_to}`).hasClass('active')) {
                    $the_gallery
                      .find(`.et_pb_gallery_pagination a.page-${page_to}`)
                      .addClass('active')
                      .trigger('click');
                  }
                }
              });
            }
          };

          window.et_pb_gallery_pagination_nav = function ($the_gallery) {
            // Remove existing handlers to prevent duplicate attachments.
            $the_gallery.off('click', '.et_pb_gallery_pagination a');

            $the_gallery.on('click', '.et_pb_gallery_pagination a', function (e) {
              e.preventDefault();

              let to_page = $(this).data('page');
              const $the_gallery = $(this).parents('.et_pb_gallery');
              const $the_gallery_items_container = $the_gallery.find('.et_pb_gallery_items');
              const $the_gallery_items = $the_gallery_items_container.find('.et_pb_gallery_item');

              // Use immediate flag check and set to prevent race conditions.
              if ($the_gallery.data('paginating')) {
                return;
              }

              // Set flag immediately to prevent concurrent executions.
              $the_gallery.data('paginating', true);

              const pagination_list = $(this).parents('ul');

              const active_page = pagination_list.find('a.active').data('page');

              // Get total pages for bounds checking
              const total_pages = pagination_list.find('li.page').length;

              if ($(this).hasClass('page-prev')) {
                to_page = Math.max(1, parseInt(active_page) - 1);
              } else if ($(this).hasClass('page-next')) {
                to_page = Math.min(total_pages, parseInt(active_page) + 1);
              }

              pagination_list.find('a').removeClass('active');
              pagination_list.find(`a.page-${to_page}`).addClass('active');

              const current_index = pagination_list.find(`a.page-${to_page}`).parent().index();

              $(this)
                .parent()
                .nextUntil(`.page-${current_index + 3}`)
                .show();
              $(this)
                .parent()
                .prevUntil(`.page-${current_index - 3}`)
                .show();

              pagination_list.find('li.page').each(function (i) {
                if (!$(this).hasClass('prev') && !$(this).hasClass('next')) {
                  if (i <= current_index - 3) {
                    $(this).hide();
                  } else if (i > current_index + 1) {
                    $(this).hide();
                  } else {
                    $(this).show();
                  }

                  if (total_pages - current_index <= 1 && total_pages - i < 5) {
                    $(this).show();
                  } else if (current_index < 2 && i <= 4) {
                    $(this).show();
                  }
                }
              });

              // Show/hide prev button based on current index.
              pagination_list.find('li.prev, li.prev-dots').toggle(to_page > 1);
              // Show/hide next button based on current index.
              pagination_list.find('li.next').toggle(!pagination_list.find('a.active').hasClass('last-page'));
              // Show/hide next dots based on current index.
              pagination_list.find('li.next-dots').toggle(current_index + 2 < total_pages);

              $the_gallery_items.hide();
              const visible_items = $the_gallery_items
                .filter(function (index) {
                  return $(this).data('page') === to_page;
                })
                .show();

              window.et_pb_set_responsive_grid($the_gallery_items_container, '.et_pb_gallery_item:visible');

              window.et_pb_smooth_scroll($the_gallery, false, 800);

              setTimeout(() => {
                set_gallery_hash($the_gallery);
                // Reset flag after all operations complete to prevent race conditions.
                $the_gallery.data('paginating', false);
              }, 100);
            });
          };
          // Attach pagination handler based on context to prevent double-firing.
          // In builder mode, only attach to builder app (which contains all galleries).
          // On frontend, only attach to gallery elements directly.
          if (isBuilder) {
            // Frontend builder's interface wouldn't be able to use $et_pb_gallery as selector
            // due to its react component's nature. Using more global selector works.
            et_pb_gallery_pagination_nav($('#et-fb-app'));
          } else {
            // Frontend: attach to gallery elements directly.
            et_pb_gallery_pagination_nav($et_pb_gallery);
          }
        } /*  end if ( $et_pb_gallery.length ) */

        $et_pb_gallery.each(function () {
          const $the_gallery = $(this);

          et_pb_gallery_init($the_gallery);
        });

        $et_pb_gallery.data('paginating', false);
      });

      // Reinitialize galleries after AJAX pagination (e.g., within Blog module)
      $(document.body).on('post-load', function () {
        // Find all gallery modules in the DOM (including newly loaded ones)
        const $galleries = $('.et_pb_gallery');

        $galleries.each(function () {
          const $the_gallery = $(this);

          // Only initialize if not already initialized or if it's a new gallery
          if (
            !$the_gallery.hasClass('et_pb_gallery_grid') ||
            !$the_gallery.find('.et_pb_gallery_pagination ul').children().length
          ) {
            et_pb_gallery_init($the_gallery);
          }
        });
      });

      // Reinitialize galleries after AJAX pagination using custom event
      window.addEventListener('divi:setPaginatedContent', function (event) {
        // Find all gallery modules in the paginated content
        const $paginatedModule = event.detail?.$current_module;

        if ($paginatedModule) {
          const $galleries = $paginatedModule.find('.et_pb_gallery');

          $galleries.each(function () {
            const $the_gallery = $(this);
            et_pb_gallery_init($the_gallery);
          });
        }
      });
    };

    window.et_pb_init_gallery_modules();
  });
})(jQuery);
